/*
 * @Date: 2019-08-26 14:33:05
 * @LastEditTime: 2020-06-22 15:34:06
 */
export default [
  {
    path: 'userList',
    name: 'userList',
    meta: {
      requireAuth: true, name: "userList", title: "用户列表"
    },
    component: resolve => require(['@/components/sysManage/userList'], resolve)
  },
  {
    path: 'characterSet',
    name: 'characterSet',
    meta: {
      requireAuth: true, name: "characterSet", title: "角色设置"
    },
    component: resolve => require(['@/components/sysManage/characterSet'], resolve)
  },
  {
    path: 'notice',
    name: 'notice',
    meta: {
      requireAuth: true, name: "notice", title: "系统公告"
    },
    component: resolve => require(['@/pages/informationManagement/notice'], resolve)
  },
  // {
  //   path: 'questionAndAnswer',
  //   name: 'questionAndAnswer',
  //   meta: {
  //     requireAuth: true, name: "questionAndAnswer", title: "常见问题解答"
  //   },
  //   component: resolve => require(['@/pages/question/answer'], resolve)
  // },
]


// WEBPACK FOOTER //
// ./src/router/sysrouter.js